export default `/* 自定义样式，实时生效，浏览器实时缓存 */

/* 全局属性
 * 页边距 padding: 30px;
 * 全文字体 font-family: ptima-Regular;
 * 英文换行 word-break: break-all;
 */
#nice {
}

/* 段落，下方未标注标签参数均同此处
 * 上边距 margin-top: 5px;
 * 下边距 margin-bottom: 5px;
 * 行高 line-height: 26px;
 * 词间距 word-spacing: 3px;
 * 字间距 letter-spacing: 3px;
 * 对齐 text-align: left;
 * 颜色 color: #3e3e3e;
 * 字体大小 font-size: 16p/* 自定义样式，实时生效，浏览器实时缓存 */

/* 全局属性
 * 页边距 padding: 30px;
 * 英文换行 word-break: break-all;
 */
#nice {
    /* 注：请在大括号内改写！！！ */
}

/* 段落，下方未标注标签参数均同此处
 * 上边距 margin-top: 5px;
 * 下边距 margin-bottom: 5px;
 * 行高 line-height: 26px;
 * 词间距 word-spacing: 3px;
 * 字间距 letter-spacing: 3px;
 * 对齐 text-align: left;
 * 颜色 color: #3e3e3e;
 * 字体大小 font-size: 16px;
 * 首行缩进 text-indent: 2em;
 */
#nice p {
    /* 注：请在大括号内改写！！！ */
  line-height: 2;
}

/* 一级标题 */
#nice h1 {
    /* 注：请在大括号内改写！！！ */
  font-size: 22px;
  margin: 2em auto 1em;
  display:flex;
  justify-content:center;
}

/* 一级标题内容 */
#nice h1 .content {
    /* 注：请在大括号内改写！！！ */
  /* border-bottom: 2px solid rgba(58, 43, 224, 1); */
  color: #fff;
  background: #3a2be0;
  padding: 0 1em;
  border-radius: 4px;
}

/* 一级标题前缀 */
#nice h1 .prefix {
    /* 注：请在大括号内改写！！！ */
}

/* 一级标题后缀 */
#nice h1 .suffix {
    /* 注：请在大括号内改写！！！ */
}

/* 二级标题 */
#nice h2 {
    /* 注：请在大括号内改写！！！ */
  font-size: 20px;
  display: flex;
  justify-content:center;
  margin-bottom: 20px;
  color: #3a2be0;
}

/* 二级标题内容 */
#nice h2 .content {
    /* 注：请在大括号内改写！！！ */
}

/* 二级标题前缀 */
#nice h2 .prefix {
    /* 注：请在大括号内改写！！！ */
}

/* 二级标题后缀 */
#nice h2 .suffix {
    /* 注：请在大括号内改写！！！ */
}

/* 三级标题 */
#nice h3 {
   font-size: 18px;
    /* 注：请在大括号内改写！！！ */
   display: flex;
   color: #3a2be0;
}

/* 三级标题内容 */
#nice h3 .content {
    /* 注：请在大括号内改写！！！ */
    /* padding-left: 8px;
    border-left: 3px solid #3a2be0; */
}

/* 三级标题前缀 */
#nice h3 .prefix {
    /* 注：请在大括号内改写！！！ */
}

/* 三级标题后缀 */
#nice h3 .suffix {
    /* 注：请在大括号内改写！！！ */
}

#nice h4 {
   font-size: 16px;
    /* 注：请在大括号内改写！！！ */
    display: flex;
    color: #3a2be0;
}
/* 无序列表整体样式
 * list-style-type: square|circle|disc;
 */
#nice ul {
    /* 注：请在大括号内改写！！！ */
  color: #3a2be0;
}
#nice ul ul{
    /* 注：请在大括号内改写！！！ */
  list-style-type:circle;
}
/* 有序列表整体样式
 * list-style-type: upper-roman|lower-greek|lower-alpha;
 */
#nice ol {
    /* 注：请在大括号内改写！！！ */
  color: #3a2be0;
}

/* 列表内容，不要设置li
 */
#nice li section {
    /* 注：请在大括号内改写！！！ */

}

/* 一级引用
 * 左边缘颜色 border-left-color: black;
 * 背景色 background: gray;
 */
#nice .multiquote-1 {
    /* 注：请在大括号内改写！！！ */
    border-left: none;
    padding: 1em;
    border-radius: 8px;
    background: #f7f7f7;
    margin: 1em 1px;
}

/* 一级引用文字 */
#nice .multiquote-1 p {
    /* 注：请在大括号内改写！！！ */
}

/* 二级引用
 */
#nice .multiquote-2 {
    /* 注：请在大括号内改写！！！ */
    /* 
      border-left: 3px solid rgba(58, 43, 224, 0.2);       */
    border-left: 3px solid #DBDBDB;
    box-shadow: none;
    padding-left: 10px;
    margin: 0.5em 1px;
    padding-bottom: 0;
    padding-top: 0;
}

/* 二级引用文字 */
#nice .multiquote-2 p {
    /* 注：请在大括号内改写！！！ */
   padding: 0;
   line-height: 1.5;
   color: rgba(0,0,0,.5);
}

/* 三级引用
 */
#nice .multiquote-3 {
    /* 注：请在大括号内改写！！！ */
}

/* 三级引用文字 */
#nice .multiquote-3 p {
    /* 注：请在大括号内改写！！！ */
}

/* 链接 
 * border-bottom: 1px solid #009688;
 */
#nice a {
    /* 注：请在大括号内改写！！！ */
  color: #3a2be0;
}

/* 加粗 */
#nice strong {
    /* 注：请在大括号内改写！！！ */
  color: #3a2be0;
}

/* 斜体 */
#nice em {
    /* 注：请在大括号内改写！！！ */
  color: #ff1700;
  font-style: normal;
  font-weight: bold;
}

/* 加粗斜体 */
#nice em strong {
    /* 注：请在大括号内改写！！！ */
  font-style: normal;
  color: #51dd50;
}

/* 删除线 */
#nice s {
    /* 注：请在大括号内改写！！！ */
    font-style:normal;
    text-decoration-color: #ff1700;
}

/* 分隔线
 * 粗细、样式和颜色
 * border-top: 1px solid #3e3e3e;
 */
#nice hr {
    /* 注：请在大括号内改写！！！ */
  border-top: 1px solid rgba(0,0,0,0.2);
}

/* 图片
 * 宽度 width: 80%;
 * 居中 margin: 0 auto;
 * 居左 margin: 0 0;
 */
#nice img {
    /* 注：请在大括号内改写！！！ */
    border-radius: 4px;
    display: block;
    margin: 0.1em auto 0.5em;
}

/* 行内代码 */
#nice p code, #nice li code {
    /* 注：请在大括号内改写！！！ */
  color: #ff6251;
}

/* 
 * 代码块不换行 display: -webkit-box !important;
 * 代码块换行 display: block;
 */
#nice pre code {
    /* 注：请在大括号内改写！！！ */
}

/*
 * 表格内的单元格
 * 字体大小 font-size: 16px;
 * 边框 border: 1px solid #ccc;
 * 内边距 padding: 5px 10px;
 */
#nice table tr th,
#nice table tr td {
    /* 注：请在大括号内改写！！！ */
}

/* 
 * 某一列表格列宽控制
 * n 可以修改为具体数字，不修改时表示所有列
 * 最小列宽 min-width: 85px;
 */
#nice table tr th:nth-of-type(n),
#nice table tr td:nth-of-type(n){
    /* 注：请在大括号内改写！！！ */
}

/* 脚注文字 */
#nice .footnote-word {
    /* 注：请在大括号内改写！！！ */
  color: #fa5151;
}

/* 脚注上标 */
#nice .footnote-ref {
    /* 注：请在大括号内改写！！！ */
  color: #fa5151;
}

/* "参考资料"四个字 
 * 内容 content: "参考资料";
 */
#nice .footnotes-sep:before {
    /* 注：请在大括号内改写！！！ */
}

/* 参考资料编号 */
#nice .footnote-num {
    /* 注：请在大括号内改写！！！ */
  width: 5%;
}
#nice .footnotes em{
    /* 注：请在大括号内改写！！！ */
  color: black;
  font-weight: normal;
}
/* 参考资料文字 */
#nice .footnote-item p { 
    /* 注：请在大括号内改写！！！ */
}

/* 参考资料解释 */
#nice .footnote-item p em {
    /* 注：请在大括号内改写！！！ */
  font-style: normal;
}

/* 行间公式
 * 最大宽度 max-width: 300% !important;
 */
#nice .block-equation svg {
    /* 注：请在大括号内改写！！！ */
}

/* 行内公式
 */
#nice .inline-equation svg {  
    /* 注：请在大括号内改写！！！ */
}

/* 容器块1 */
#nice .block-1 {
    /* 注：请在大括号内改写！！！ */
}

/* 容器块2 */
#nice .block-2 {
    /* 注：请在大括号内改写！！！ */
}

/* 容器块3 */
#nice .block-3 {
    /* 注：请在大括号内改写！！！ */
}

/* 分列总体布局 */
#nice .column {
    /* 注：请在大括号内改写！！！ */
}

/* 分列左边布局 */
#nice .column .column-left {
    /* 注：请在大括号内改写！！！ */
}

/* 分列右边布局 */
#nice .column .column-right {
    /* 注：请在大括号内改写！！！ */
}x;
 * 首行缩进 text-indent: 2em;
 */
#nice p {
}

/* 一级标题 */
#nice h1 {
}

/* 一级标题内容 */
#nice h1 .content {
}

/* 一级标题前缀 */
#nice h1 .prefix {
}

/* 一级标题后缀 */
#nice h1 .suffix {
}

/* 二级标题 */
#nice h2 {
}

/* 二级标题内容 */
#nice h2 .content {
}

/* 二级标题前缀 */
#nice h2 .prefix {
}

/* 二级标题后缀 */
#nice h2 .suffix {
}

/* 三级标题 */
#nice h3 {
}

/* 三级标题内容 */
#nice h3 .content {
}

/* 三级标题前缀 */
#nice h3 .prefix {
}

/* 三级标题后缀 */
#nice h3 .suffix {
}

/* 无序列表整体样式
 * list-style-type: square|circle|disc;
 */
#nice ul {
}

/* 有序列表整体样式
 * list-style-type: upper-roman|lower-greek|lower-alpha;
 */
#nice ol {
}

/* 列表内容，不要设置li
 */
#nice li section {
}

/* 一级引用
 * 左边缘颜色 border-left-color: black;
 * 背景色 background: gray;
 */
#nice .multiquote-1 {
}

/* 一级引用文字 */
#nice .multiquote-1 p {
}

/* 二级引用
 */
#nice .multiquote-2 {
}

/* 二级引用文字 */
#nice .multiquote-2 p {
}

/* 三级引用
 */
#nice .multiquote-3 {
}

/* 三级引用文字 */
#nice .multiquote-3 p {
}

/* 链接 
 * border-bottom: 1px solid #009688;
 */
#nice a {
}

/* 加粗 */
#nice strong {
}

/* 斜体 */
#nice em {
}

/* 加粗斜体 */
#nice em strong {
}

/* 删除线 */
#nice del {
}

/* 分隔线
 * 粗细、样式和颜色
 * border-top: 1px solid #3e3e3e;
 */
#nice hr {
}

/* 图片
 * 宽度 width: 80%;
 * 居中 margin: 0 auto;
 * 居左 margin: 0 0;
 */
#nice img {
}

/* 行内代码 */
#nice p code, #nice li code {
}

/* 
 * 代码块不换行 display: -webkit-box !important;
 * 代码块换行 display: block;
 */
#nice pre code {
}

/*
 * 表格内的单元格
 * 字体大小 font-size: 16px;
 * 边框 border: 1px solid #ccc;
 * 内边距 padding: 5px 10px;
 */
#nice table tr th,
#nice table tr td {
}

/* 
 * 某一列表格列宽控制
 * n 可以修改为具体数字，不修改时表示所有列
 * 最小列宽 min-width: 85px;
 */
#nice table tr th:nth-of-type(n),
#nice table tr td:nth-of-type(n){
}

/* 脚注文字 */
#nice .footnote-word {
}

/* 脚注上标 */
#nice .footnote-ref {
}

/* "参考资料"四个字 
 * 内容 content: "参考资料";
 */
#nice .footnotes-sep:before {
}

/* 参考资料编号 */
#nice .footnote-num {
  width: 6%;
}

/* 参考资料文字 */
#nice .footnote-item p { 
}

/* 参考资料解释 */
#nice .footnote-item p em {
}

/* 行间公式
 * 最大宽度 max-width: 300% !important;
 */
#nice .block-equation svg {
}

/* 行内公式
 */
#nice .inline-equation svg {  
}`;
